/**
 * The scene of a 2D canvas's World3D, which every shared-world SubViewport of that canvas draws.
 * Godot's `find_world_3d()` reaches the canvas's one world from each of them
 * (`viewport.cpp:4670-4681`), so their nodes share one scene.
 */
import { createContext, useContext, useLayoutEffect } from 'react';
/** Written by `CanvasWorldScope`, and set to null by an own world. Null outside a 2D canvas. */
export const CanvasWorldContext = createContext(null);
CanvasWorldContext.displayName = 'CanvasWorldContext';
/** The World3D of the enclosing 2D canvas, or null outside one. */
export function useCanvasWorld() {
    return useContext(CanvasWorldContext);
}
/**
 * Keeps `world` drawn while the caller is mounted. A world nobody draws applies no Environment,
 * shadow fit or depth prepass, as Godot draws no World3D without a camera into it.
 */
export function useDrawCanvasWorld(world) {
    useLayoutEffect(() => world?.hold(), [world]);
}
//# sourceMappingURL=canvasWorldScene.js.map